import { render, staticRenderFns } from "./SparepartsItemTable.vue?vue&type=template&id=7a0c314a&"
import script from "./SparepartsItemTable.vue?vue&type=script&lang=js&"
export * from "./SparepartsItemTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports